
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.16 15.428h6.106l-1.228 6.739a.937.937 0 001.665.74l9.878-12.827a.938.938 0 00-.743-1.51h-6.106l1.229-6.738a.938.938 0 00-1.666-.74L3.417 13.92a.937.937 0 00.743 1.51zm8.263-10.13l-.737 4.042a.938.938 0 00.923 1.105h5.324l-6.357 8.256.736-4.042a.938.938 0 00-.922-1.106H6.066l6.357-8.255z","fill":"#fff"}})])
          )
        }
      }
    